export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "AccountingService",
  "name": "Bookkeeping Services South Africa",
  "description": "SAICA Registered bookkeeping services using Xero for South African businesses. Entry Level from R2,500/month.",
  "url": "https://bookkeepingservices.co.za",
  "email": "info@bookkeepingservices.co.za",
  "telephone": "+27-000-000-0000",
  "priceRange": "R300 - R4500/month",
  "knowsAbout": ["Xero Accounting Software", "SAICA Standards", "SARS Compliance"],
  "areaServed": {
    "@type": "Country",
    "name": "South Africa"
  },
  "serviceType": [
    "Bookkeeping",
    "Payroll Services",
    "Tax Returns",
    "SARS Compliance",
    "Annual Financial Statements",
    "CIPC Annual Returns",
    "VAT Registration",
    "Company Registration"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Bookkeeping Service Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "Basic Package",
        "price": "300",
        "priceCurrency": "ZAR",
        "description": "Nil turnover annual returns and CIPC compliance"
      },
      {
        "@type": "Offer",
        "name": "Entry Level Package",
        "price": "2500",
        "priceCurrency": "ZAR",
        "description": "SAICA Registered bookkeeping on Xero — monthly bookkeeping, payroll (1-5 employees), tax returns, EMP201, EMP501, UIF & CIPC. Up to R2.3m turnover."
      },
      {
        "@type": "Offer",
        "name": "Medium Level Package",
        "price": "4500",
        "priceCurrency": "ZAR",
        "description": "Full-service bookkeeping on Xero — includes VAT201, payroll (1-10 employees), workmen's compensation & full compliance. Up to R12m turnover."
      }
    ]
  },
  "sameAs": []
};

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What accounting software do you work with?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We work with all major South African accounting platforms including Sage, Xero, QuickBooks, and Pastel. We'll use whichever system works best for your business."
      }
    },
    {
      "@type": "Question",
      "name": "How quickly can you start?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We can typically onboard new clients within 48 hours. Book a call and we'll have you set up by the end of the week."
      }
    },
    {
      "@type": "Question",
      "name": "Do you handle SARS audits?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide full support during SARS audits and can represent you in discussions with SARS when needed."
      }
    },
    {
      "@type": "Question",
      "name": "What if my books are behind?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No problem! We specialize in catching up backlogged books. We'll assess your situation and provide a clear plan to get you current."
      }
    }
  ]
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Bookkeeping Services South Africa",
  "description": "SAICA registered bookkeeping and accounting services for South African businesses. Chartered Accountant-led practice offering payroll, tax returns, and SARS compliance from R300/month.",
  "url": "https://bookkeepingservices.co.za",
  "email": "info@bookkeepingservices.co.za",
  "priceRange": "R300 - R4500",
  "areaServed": "South Africa",
  "serviceArea": {
    "@type": "Country",
    "name": "South Africa"
  },
  "openingHours": "Mo-Fr 08:00-17:00",
  "knowsAbout": ["SAICA", "SARS Compliance", "Xero", "Payroll", "Tax Returns"],
  "hasCredential": {
    "@type": "EducationalOccupationalCredential",
    "credentialCategory": "Professional Certification",
    "name": "SAICA Registered Chartered Accountant"
  }
};

export const siteNavigationSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "SiteNavigationElement",
      "name": "Services",
      "description": "Bookkeeping, payroll, tax returns, SARS compliance and more",
      "url": "https://bookkeepingservices.co.za/services"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Packages & Pricing",
      "description": "SAICA Registered bookkeeping on Xero from R2,500/month",
      "url": "https://bookkeepingservices.co.za/packages"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "About Us",
      "description": "SAICA registered bookkeeping professionals",
      "url": "https://bookkeepingservices.co.za/about"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Payroll Services",
      "description": "EMP201, EMP501, UIF declarations and payroll processing",
      "url": "https://bookkeepingservices.co.za/payroll-services"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Tax Returns & SARS",
      "description": "Annual tax returns, provisional tax, and SARS compliance",
      "url": "https://bookkeepingservices.co.za/tax-returns-sars-compliance"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Book a Call",
      "description": "Schedule a free consultation with our bookkeeping team",
      "url": "https://bookkeepingservices.co.za/book-a-call"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Contact",
      "description": "Get in touch with Bookkeeping Services South Africa",
      "url": "https://bookkeepingservices.co.za/contact"
    }
  ]
};

// Services page schema
export const servicesPageSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "provider": {
    "@type": "AccountingService",
    "name": "Bookkeeping Services South Africa",
    "url": "https://bookkeepingservices.co.za"
  },
  "name": "Bookkeeping & Compliance Services",
  "description": "Professional bookkeeping, payroll, tax returns, and SARS compliance services for South African businesses.",
  "areaServed": { "@type": "Country", "name": "South Africa" },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Bookkeeping Services",
    "itemListElement": [
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Monthly Bookkeeping", "description": "Accurate recording of all financial transactions including invoices, receipts, and bank statements." } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Payroll Processing (EMP201, EMP501)", "description": "Complete payroll processing including monthly EMP201 submissions and bi-annual EMP501 reconciliations." } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "UIF Monthly Declarations", "description": "Timely submission of UIF declarations to the Department of Labour." } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Annual Financial Statements", "description": "Professionally prepared annual financial statements that meet SARS requirements." } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Annual Tax Returns", "description": "Preparation and submission of annual income tax returns ensuring all deductions are claimed." } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "CIPC Annual Returns", "description": "On-time submission of your company's annual return to CIPC." } }
    ]
  }
};

// Packages page schema  
export const packagesPageSchema = {
  "@context": "https://schema.org",
  "@type": "OfferCatalog",
  "name": "Bookkeeping Service Packages — South Africa",
  "description": "Transparent, all-inclusive bookkeeping packages for South African businesses from R300/month.",
  "provider": {
    "@type": "AccountingService",
    "name": "Bookkeeping Services South Africa"
  },
  "itemListElement": [
    {
      "@type": "Offer",
      "name": "Basic Package",
      "price": "300",
      "priceCurrency": "ZAR",
      "priceSpecification": { "@type": "UnitPriceSpecification", "price": "300", "priceCurrency": "ZAR", "unitText": "MONTH" },
      "description": "Nil turnover: annual tax return, 2x provisional tax, CIPC annual return, beneficial ownership."
    },
    {
      "@type": "Offer",
      "name": "Entry Level Package",
      "price": "2500",
      "priceCurrency": "ZAR",
      "priceSpecification": { "@type": "UnitPriceSpecification", "price": "2500", "priceCurrency": "ZAR", "unitText": "MONTH" },
      "description": "Bookkeeping up to 60 entries, payroll 1-5 employees, EMP201, EMP501, UIF, AFS, tax returns, CIPC. Turnover up to R2.3m."
    },
    {
      "@type": "Offer",
      "name": "Medium Level Package",
      "price": "4500",
      "priceCurrency": "ZAR",
      "priceSpecification": { "@type": "UnitPriceSpecification", "price": "4500", "priceCurrency": "ZAR", "unitText": "MONTH" },
      "description": "Bookkeeping up to 120 entries, VAT201, payroll 1-10 employees, workmen's compensation, full compliance. Turnover up to R12m."
    }
  ]
};

// Contact page schema
export const contactPageSchema = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "name": "Contact Bookkeeping Services South Africa",
  "description": "Get in touch for professional bookkeeping, payroll, and SARS compliance services.",
  "url": "https://bookkeepingservices.co.za/contact",
  "mainEntity": {
    "@type": "AccountingService",
    "name": "Bookkeeping Services South Africa",
    "email": "info@bookkeepingservices.co.za",
    "areaServed": { "@type": "Country", "name": "South Africa" },
    "openingHours": "Mo-Fr 08:00-17:00",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "email": "info@bookkeepingservices.co.za",
      "availableLanguage": "English"
    }
  }
};

// About page schema
export const aboutPageSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "name": "About Bookkeeping Services South Africa",
  "description": "SAICA registered Chartered Accountant-led bookkeeping practice serving SMEs, startups, and growing businesses across South Africa.",
  "url": "https://bookkeepingservices.co.za/about",
  "mainEntity": {
    "@type": "AccountingService",
    "name": "Bookkeeping Services South Africa",
    "description": "SAICA registered bookkeeping practice",
    "hasCredential": {
      "@type": "EducationalOccupationalCredential",
      "credentialCategory": "Professional Certification",
      "name": "SAICA Registered Chartered Accountant"
    },
    "knowsAbout": [
      "SAICA Standards",
      "SARS Compliance",
      "Xero Accounting",
      "Payroll Processing",
      "Tax Returns",
      "CIPC Compliance"
    ]
  }
};

// Payroll service schema
export const payrollServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Payroll Services South Africa — EMP201, EMP501, UIF",
  "provider": {
    "@type": "AccountingService",
    "name": "Bookkeeping Services South Africa",
    "url": "https://bookkeepingservices.co.za"
  },
  "description": "Complete payroll processing for South African businesses including EMP201 monthly submissions, EMP501 bi-annual reconciliations, and UIF declarations. SAICA registered.",
  "areaServed": { "@type": "Country", "name": "South Africa" },
  "serviceType": ["Payroll Processing", "EMP201 Submissions", "EMP501 Reconciliation", "UIF Declarations"],
  "offers": {
    "@type": "Offer",
    "description": "Payroll included in bookkeeping packages from R2,500/month",
    "priceCurrency": "ZAR"
  }
};

export const payrollFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is EMP201 and when is it due?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "EMP201 is a monthly employer declaration submitted to SARS. It reports PAYE, UIF, and SDL deducted from employee salaries. It is due by the 7th of each month following the payroll period. Late submissions incur penalties and interest from SARS."
      }
    },
    {
      "@type": "Question",
      "name": "What is EMP501 and how often is it submitted?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "EMP501 is a bi-annual employer reconciliation submitted to SARS. It reconciles all EMP201 submissions for the tax year and is submitted during the interim period (September–October) and the annual period (April–May). It ensures that the total PAYE, UIF, and SDL reported matches what was deducted."
      }
    },
    {
      "@type": "Question",
      "name": "How do UIF declarations work in South Africa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "UIF (Unemployment Insurance Fund) contributions are mandatory for all employers. Both the employer and employee contribute 1% of the employee's remuneration, totalling 2%. Monthly UIF declarations must be submitted to the Department of Labour, and contributions are paid over to SARS via the EMP201."
      }
    },
    {
      "@type": "Question",
      "name": "What happens if I miss a payroll submission deadline?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Missing SARS payroll deadlines (EMP201 by the 7th monthly, EMP501 bi-annually) results in penalties of up to 10% of the outstanding amount plus interest. We ensure all submissions are made on time to keep your business compliant and penalty-free."
      }
    },
    {
      "@type": "Question",
      "name": "How many employees can you handle on payroll?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our Entry Level package covers 1-5 employees and our Medium Level package covers 1-10 employees. For larger teams, we provide custom quotes tailored to your business size and needs."
      }
    }
  ]
};

// Tax & SARS compliance schema
export const taxSarsServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Tax Returns & SARS Compliance Services — South Africa",
  "provider": {
    "@type": "AccountingService",
    "name": "Bookkeeping Services South Africa",
    "url": "https://bookkeepingservices.co.za"
  },
  "description": "Professional tax return preparation and SARS compliance services for South African businesses. Annual income tax, provisional tax, VAT201, and audit support by a SAICA registered practice.",
  "areaServed": { "@type": "Country", "name": "South Africa" },
  "serviceType": ["Annual Tax Returns", "Provisional Tax Returns", "VAT201 Submissions", "SARS Audit Support", "SARS Compliance"]
};

export const taxFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "When are annual tax returns due in South Africa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "For non-provisional taxpayers, annual income tax returns are typically due between July and October. Provisional taxpayers have two submission periods: the first within six months of the start of the tax year, and the second at the end of the tax year. SARS announces exact dates each year, and we track all deadlines for our clients."
      }
    },
    {
      "@type": "Question",
      "name": "What is provisional tax and who needs to pay it?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Provisional tax is a method of paying income tax in advance, in two instalments during the tax year. It applies to individuals who earn income other than employment income (e.g., rental income, business income) and to all registered companies. This prevents a large tax bill at year-end."
      }
    },
    {
      "@type": "Question",
      "name": "What happens during a SARS audit?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "During a SARS audit, SARS reviews your tax returns, financial records, and supporting documents to verify accuracy. We provide full audit support including preparation of required documentation, liaison with SARS officials, and representation during audit proceedings to ensure the best possible outcome."
      }
    },
    {
      "@type": "Question",
      "name": "Do I need to register for VAT in South Africa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "VAT registration is compulsory if your taxable turnover exceeds R1 million in any consecutive 12-month period. Voluntary registration is available if turnover exceeds R50,000. Once registered, VAT201 returns must be submitted bi-monthly or monthly depending on your turnover level."
      }
    },
    {
      "@type": "Question",
      "name": "What penalties does SARS charge for late submissions?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "SARS charges administrative penalties based on your assessed tax liability, ranging from R250 to R16,000 per month that a return is outstanding. Interest is also charged on late payments at the prescribed rate. We ensure all your returns are submitted on time to avoid these costly penalties."
      }
    }
  ]
};

// Annual Financial Statements schema
export const afsServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Annual Financial Statements & CIPC Compliance — South Africa",
  "provider": {
    "@type": "AccountingService",
    "name": "Bookkeeping Services South Africa",
    "url": "https://bookkeepingservices.co.za"
  },
  "description": "Professionally prepared annual financial statements, CIPC annual returns, beneficial ownership submissions, and workmen's compensation returns for South African businesses.",
  "areaServed": { "@type": "Country", "name": "South Africa" },
  "serviceType": ["Annual Financial Statements", "CIPC Annual Returns", "Beneficial Ownership Submissions", "Workmen's Compensation Returns"]
};

export const afsFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What are annual financial statements (AFS)?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Annual financial statements (AFS) are a formal record of a business's financial performance and position over a 12-month period. They typically include a statement of financial position (balance sheet), statement of comprehensive income (income statement), statement of changes in equity, and notes. AFS are required by SARS for income tax purposes and by CIPC for compliance."
      }
    },
    {
      "@type": "Question",
      "name": "What is a CIPC annual return and when is it due?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A CIPC annual return is a mandatory filing with the Companies and Intellectual Property Commission confirming your company's details are up to date. It is due within 30 business days of your company's registration anniversary date each year. Failure to file can result in your company being deregistered."
      }
    },
    {
      "@type": "Question",
      "name": "What is beneficial ownership (BO) and why is it important?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Beneficial ownership refers to the natural persons who ultimately own or control a company. Since April 2023, all companies in South Africa must file a beneficial ownership register with CIPC. This is part of South Africa's anti-money laundering and transparency obligations under the Companies Amendment Act."
      }
    },
    {
      "@type": "Question",
      "name": "What is workmen's compensation and does my business need it?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Workmen's compensation (COIDA) is insurance that covers employees who are injured, disabled, or killed at work. All employers in South Africa with one or more employees must register with the Compensation Fund and submit an annual return of earnings. This ensures your employees are covered and your business is compliant."
      }
    }
  ]
};

// Breadcrumb schema generator
export const generateBreadcrumbSchema = (items: Array<{ name: string; url: string }>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});
